export default __webpack_public_path__ + "static/media/01.d52a42da.jpg";